export class Generic {
    sid: string;
    name: string;
}
